import { getAPICall, postAPICall } from './BaseAPI';

export const getNotesData = async (payload, cb = (jR, s, e) => {}) => {
  return await postAPICall('notes/getnotesdata/', payload, cb);
};

export const saveNote = async (payload, cb = (jR, s, e) => {}) => {
  return await postAPICall('notes/createnote/', payload, cb);
};

export const deleteNote = async (id, cb = (jR, s, e) => {}) => {
  const payload = { id };
  return await postAPICall('notes/deletenote/', payload, cb);
};

export const updateNote = async (payload, cb = (jR, s, e) => {}) => {
  return await postAPICall('notes/updatenote/', payload, cb);
};
